import { toHump, str2Date, fen2Yuan } from './tools';
/**
 * 格式化数组元素
 * @param arr 需要格式化的数组
 * @param needParseIntKey 需要转成 int 类型的 key 数组
 * @param needParseDateKey 需要转成 date 类型的 key 数组
 * @returns
 */
const handleFormatArrVal = (options) => {
    const { result } = options;
    return result.map((ele) => {
        // 如果是素组元素
        if (Array.isArray(ele)) {
            return handleFormatArrVal(Object.assign(Object.assign({}, options), { result: ele }));
        }
        // 如果是对象元素
        if (Object.prototype.toString.call(ele) === '[object Object]') {
            return handleFormatRes(Object.assign(Object.assign({}, options), { result: ele }));
        }
        return ele;
    });
};
/**
 * 处理 cgi 返回值：key 改成驼峰，值根据真实需要转换
 * @category global
 * @param options FormatResOptions
 * @returns
 */
export const handleFormatRes = (options) => {
    const { result, needParseIntKey = [], needParseDateKey = [], needParseBoolKey = [], needFen2YuanKey = [], transformer, } = options;
    const res = {};
    for (const [key, value] of Object.entries(result)) {
        // 转换 key 为驼峰形式
        const toHumpKey = toHump(key);
        // fen2yuan
        if (needParseIntKey.includes(toHumpKey)) {
            // 转换并返回 number 类型的数据
            res[toHumpKey] = parseInt(value, 10);
        }
        else if (needParseDateKey.includes(toHumpKey)) {
            // 转换并返回 date 类型的数据
            res[toHumpKey] = str2Date(value);
        }
        else if (needParseBoolKey.includes(toHumpKey)) {
            res[toHumpKey] = Boolean(+value);
        }
        else if (needFen2YuanKey.includes(toHumpKey)) {
            res[toHumpKey] = +fen2Yuan(value);
        }
        else {
            if (Array.isArray(value)) {
                // 如果返回值是数组
                res[toHumpKey] = handleFormatArrVal(Object.assign(Object.assign({}, options), { result: value, transformer: undefined }));
            }
            else if (Object.prototype.toString.call(value) === '[object Object]') {
                // 如果返回值是对象
                res[toHumpKey] = handleFormatRes(Object.assign(Object.assign({}, options), { result: value, transformer: undefined }));
            }
            else {
                res[toHumpKey] = value;
            }
        }
    }
    if (transformer) {
        return transformer(res);
    }
    return res;
};
/**
 * 处理头像和昵称
 * @param faceUrl 头像
 * @param nickName 昵称
 */
export const formatFaceUrlNickname = (faceUrl, nickName) => ({
    faceUrl: atob(faceUrl || ''),
    nickName: decodeURIComponent(escape(atob(nickName || ''))),
});
